<script generic="TData, TValue extends string | number" lang="ts" setup>
import { useSlots } from 'vue';
import { type RadioOption } from './types';

const props = defineProps<{
  options: RadioOption<TData, TValue>[];
}>();

const model = defineModel<TValue>();
const slots = useSlots();
</script>

<template>
  <label
    v-for="{ data, value } in props.options"
    class="grid cursor-pointer gap-x-5 rounded-lg border border-solid px-5 py-4 outline outline-primary transition-all duration-100"
    :class="{
      'grid-cols-[1fr_auto]': !slots.id,
      'grid-cols-[auto_1fr_auto]': slots.id,
      'border-grey-200 outline-0': model !== value,
      'border-transparent outline-offset-2': model === value,
    }"
    :data-testid="`v-radio-options__option v-radio-options__option-${value}`"
    :key="value"
  >
    <div v-if="slots.id" class="font-bold">
      <slot v-bind="data" name="id"></slot>
    </div>

    <header v-if="slots.default" class="font-bold">
      <slot v-bind="data"></slot>
    </header>

    <footer
      v-if="slots.description"
      class="text-xs text-grey"
      :class="{
        'col-start-1 col-end-1': !slots.id,
        'col-start-2 col-end-2': slots.id,
      }"
    >
      <slot v-bind="data" name="description"></slot>
    </footer>

    <input
      v-model="model"
      class="col-start-3 row-span-2 row-start-1 size-5 self-center accent-primary"
      type="radio"
      :value
    />
  </label>
</template>
